import React from 'react';
import {
  Grid,
  Typography,
  Box
} from '@mui/material';
import ProductCard from './ProductCard';
import { Product } from '../types';

interface ProductListProps {
  products: Product[];
  onAddToCart: (product: Product) => void;
  onDownload: (product: Product) => void;
  loading?: boolean;
  onRequireLogin?: () => void;
  onFavoriteAdded?: () => void;
}

const ProductList: React.FC<ProductListProps> = ({
  products,
  onAddToCart,
  onDownload,
  loading = false,
  onRequireLogin,
  onFavoriteAdded
}) => {
  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography>Loading products...</Typography>
      </Box>
    );
  }

  if (products.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          No products found
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Try adjusting your search criteria or browse all categories
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {products.map((product) => (
        <Grid item xs={12} sm={6} md={4} key={product.id}>
          <ProductCard
            product={product}
            onAddToCart={onAddToCart}
            onDownload={onDownload}
            onRequireLogin={onRequireLogin}
            onFavoriteAdded={onFavoriteAdded}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductList; 